import { Component } from '@angular/core';

import { YoutubePlayerComponent } from '@shared/components';

@Component({
  selector: 'app-full-evrn-demo',
  templateUrl: './full-evrn-demo.html',
  styleUrl: './full-evrn-demo.scss',
  imports: [YoutubePlayerComponent],
})
export class FullEvrnDemo {}
